import { Outlet } from 'react-router';
import { UserManagementTemplate } from '@/ui/templates';
import { ActionsPanel, CreateEditUserSidebar } from './components';
import { useCallback, useState } from 'react';

export const UsersManagementLayout = () => {
  const [isCreateEditUserSidebarVisible, setIsCreateEditUserSidebarVisible] = useState<boolean>(false);

  const handleCreateOrEditNewUser = useCallback(() => {
    setIsCreateEditUserSidebarVisible(true);
  }, []);

  const handleCloseUserSidebarClick = useCallback(() => {
    setIsCreateEditUserSidebarVisible(false);
  }, []);

  return (
    <UserManagementTemplate actionsPanel={<ActionsPanel handleCreateNewUser={handleCreateOrEditNewUser} />}>
      <div className="flex h-full w-full flex-col px-6 pb-4">
        {isCreateEditUserSidebarVisible && <CreateEditUserSidebar closeSidebar={handleCloseUserSidebarClick} />}

        <Outlet context={{ handleCreateOrEditNewUser: handleCreateOrEditNewUser }} />
      </div>
    </UserManagementTemplate>
  );
};
